import * as React from 'react';
import { createContext, useContext, useRef, useState } from 'react';
import Toast, {type ToastOptions } from './Toast';

const ToastContext = createContext<((options: ToastOptions) => Promise<boolean>) | null>(null);

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within an ToastProvider");
    }
    return context;
}

const ToastProvider = (props: { children: React.ReactNode }) => {
    const [toastState, setToastState] = useState<ToastOptions | null>(null);
    const resolver = useRef<(value: boolean) => void | undefined>(undefined);

    const openToast = (options: ToastOptions) => {
        setToastState(options);
        return new Promise<boolean>((resolve) => {
            resolver.current = resolve;
        });
    };

    const handleClose = () => {
        resolver.current?.(false);
        setToastState(null);
    };

    return (
        <>
            <ToastContext.Provider
                value={openToast}
                children={props.children}
            />

            <Toast open={Boolean(toastState)} severity={toastState?.severity ?? "info"} message={toastState?.message ?? ""} onClose={handleClose} />        
        </>
    )
}

export default ToastProvider;